import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/chevron-down-small.svg";
var ChevronDownSmallSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ChevronDownSmallSolid_default as default
};
